// Backend list endpoints return either a plain array or a paginated envelope
// ({ items, total, page, size, pages }). This normalizes both to an array so
// callers can safely .filter/.map/.length the result.
export const asList = <T = any>(data: any): T[] => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.items)) return data.items;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};
